module.exports = __webpack_public_path__ + "img/leakalert_testjig.ff5c9527.jpg";